import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesOcorrenciasEnviar.vue?vue&type=template&id=4f4736a4"
import script from "./LicitacaoAtualizacaoAcoesOcorrenciasEnviar.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesOcorrenciasEnviar.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoAtualizacaoAcoesOcorrenciasEnviar.vue?vue&type=style&index=0&id=4f4736a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports